import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ComdataAvailableLimitTooltipProps {
  className?: string
  openLeft: boolean
}

const ComdataAvailableLimitTooltip: React.FC<
  ComdataAvailableLimitTooltipProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip className={props.className} openLeft={props.openLeft}>
      <p>
        {translate(
          "${comdataAccountInfo} displays the current available limit on your Comdata account. Reaching this limit won't prevent you from issuing virtual cards, but any charges will be declined. To view the most up-to-date limit from Comdata, refresh this page.",
          {
            comdataAccountInfo: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Comdata Account Info')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default ComdataAvailableLimitTooltip
